import axios from "axios";

const TOKEN_KEY = "customerToken";
const USER_KEY = "customerUser";
const LAST_ACTIVITY_KEY = "customerLastActivity";

// 30 min de inatividade = logout automatico
export const IDLE_TIMEOUT_MS = 30 * 60 * 1000;

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getUser() {
  const raw = localStorage.getItem(USER_KEY);
  try { return raw ? JSON.parse(raw) : null; } catch { return null; }
}

export function setSession(token, user) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  touchActivity();
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(LAST_ACTIVITY_KEY);
}

export function touchActivity() {
  localStorage.setItem(LAST_ACTIVITY_KEY, String(Date.now()));
}

export function isIdleExpired() {
  const last = parseInt(localStorage.getItem(LAST_ACTIVITY_KEY) || "0", 10);
  return last > 0 && Date.now() - last > IDLE_TIMEOUT_MS;
}

// JWT exp claim em segundos epoch — checa local sem chamar backend
export function isTokenExpired(token) {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (!payload.exp) return false;
    return Date.now() >= payload.exp * 1000;
  } catch {
    return true;
  }
}

let interceptorInstalled = false;
export function installAuthInterceptor(onLogout) {
  if (interceptorInstalled) return;
  interceptorInstalled = true;

  axios.interceptors.request.use((config) => {
    const token = getToken();
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = "Bearer " + token;
    }
    return config;
  });

  axios.interceptors.response.use(
    (resp) => resp,
    (err) => {
      if (err.response?.status === 401) {
        clearSession();
        if (onLogout) onLogout();
      }
      return Promise.reject(err);
    }
  );
}
